<script setup>
import {parseDate, formatDate} from '@/core/util/helper/datefns';
import {defineProps, ref, computed} from 'vue';
import {APIService} from '@/core/util/services/api.service';
const props = defineProps({
  id: {type: Number},
  training: {type: Object},
  participant: {type: Object},
});

const isLoading = ref(false);
const isEdit = ref(props.participant.edit);
const participantModel = ref(props.participant);

// Http Api
const http = new APIService(window.appGlobal.baseUrl, 'api');

const onSave = () => {
  isLoading.value = true;

  let url = `api/training-participants/${props.id}/participants`;

  const formData = new FormData();

  formData.append('participants[]', JSON.stringify(participantModel.value));
  formData.append('fromPresenceTab', 1);

  if (isEdit.value) url = `${url}?_method=PUT`;

  http
    .request({
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      method: 'POST',
      url: url,
      data: formData,
    })
    .then(response => {
      window.location.assign(
        `${window.appGlobal.baseUrl}/training/viewTrainingPlan`,
      );
    })
    .finally(() => {
      isLoading.value = false;
    });
};

const canAttendance = computed(() => {
  const startDate = new Date(props.training.start_date);
  const now = new Date();
  return startDate <= now;
});

const canEditPresences = ref(true);

const trainingSchedulesIds = props.training.training_schedule.map(ts => ts.id);
const schedulesIds = props.participant.schedules.map(s => s);
canEditPresences.value =
  JSON.stringify(trainingSchedulesIds) !== JSON.stringify(schedulesIds);
</script>
<template>
  <div>
    <br />
    <oxd-text tag="h6">
      Attendances, Assessement and Relevance
    </oxd-text>
    <br />
    <div class="orangehrm-background-container">
      <oxd-form :loading="isLoading" @submitValid="onSave">
        <oxd-form-row>
          <oxd-grid :cols="3" class="orangehrm-full-width-grid">
            <oxd-grid-item>
              <oxd-input-field
                :value="participantModel.effectiveness ? 'Yes' : 'No'"
                label="Effectiveness"
                :disabled="true"
              />
            </oxd-grid-item>
            <oxd-grid-item>
              <oxd-input-field
                :value="participantModel.score"
                label="Score"
                :disabled="true"
              />
            </oxd-grid-item>
            <oxd-grid-item>
              <oxd-input-field
                v-model="participantModel.relevante_job"
                type="checkbox"
                option-label="Relevant for the job"
              />
            </oxd-grid-item>
          </oxd-grid>
          <oxd-divider />
          <oxd-grid :cols="3" class="orangehrm-full-width-grid">
            <template
              v-for="schedule in training.training_schedule"
              :key="schedule.id"
            >
              <oxd-grid-item>
                <oxd-input-field
                  type="date"
                  :value="schedule.date"
                  label="Date"
                  :disabled="true"
                />
              </oxd-grid-item>
              <oxd-grid-item>
                <time-input
                  :model-value="schedule.hour"
                  label="Hour"
                  :disabled="true"
                />
              </oxd-grid-item>
              <oxd-grid-item>
                <oxd-input-field
                  v-if="canAttendance"
                  v-model="participantModel.schedules"
                  type="checkbox"
                  :value="schedule.id"
                  :disabled="!canEditPresences"
                  option-label="Was present"
                />
              </oxd-grid-item>
            </template>
          </oxd-grid>
          <oxd-text
            v-if="!canAttendance"
            style="font-size: 0.75rem"
            class="oxd-input-field-error-message"
            >Attendance records will only be available from
            {{
              formatDate(parseDate(training.start_date), 'dd-MM-yyyy')
            }}</oxd-text
          >
          <oxd-divider />
          <oxd-grid :cols="1" class="orangehrm-full-width-grid">
            <oxd-grid-item class="--span-column-4">
              <oxd-input-field
                v-model="participantModel.comment"
                type="textarea"
                :disabled="!canEditPresences"
                label="Comments"
                placeholder="Comments"
              />
            </oxd-grid-item>
          </oxd-grid>
        </oxd-form-row>
        <oxd-divider />
        <oxd-form-actions>
          <submit-button />
        </oxd-form-actions>
      </oxd-form>
    </div>
  </div>
</template>
<style scoped>
.w-100 {
  width: 100%;
}

.w-20 {
  width: 20%;
}

.flex {
  display: flex;
}

.gap-3 {
  gap: 3px;
}

table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
}

.td-style {
  border: 1px solid black !important;
  padding: 10px !important;
  text-align: center !important;
}
</style>
